import React from 'react';
import Icon from 'components/Icon';

import styles from './EmptyState.scss';

const EntitySearchEmptyState = () => (
  <div className={styles.container}>
    <Icon iconType="quotes_open" className={styles.emptyStateIcon} />
    <span className={styles.empyStateTitle}>
      Search and Add or Create Entities
    </span>
    <span className={styles.emptyStateSubtitle}>
      {
        "Examples of entities:  When you need a user's email ID and need to verify that inputs are valid IDs or not. The ‘email’ entity allows the detection of an email id."
      }
    </span>
    <Icon
      iconType="quotes_close"
      className={`${styles.emptyStateIcon} ${styles.closeIcon}`}
    />
  </div>
);

export default EntitySearchEmptyState;
